export const PORTAL_MASK_EXTENT = 100000;
export const PORTAL_MASK_SEAM = 1;

// The source body lives in the open room in front of the entrance. Keep that
// half-plane unbounded so ordinary limbs outside the opening do not disappear;
// the physical cap fixtures still decide whether the island actually fits. A
// part that has not come in through the opening also shows behind the plane
// beyond the opening's ends, where it went round the portal.
export const sourcePortalMaskQuads = (
	apertureHalfLengthPixels = PORTAL_MASK_EXTENT,
	admitted = true,
) => {
	const front = {
		normalMin: -PORTAL_MASK_SEAM,
		normalMax: PORTAL_MASK_EXTENT,
		tangentMin: -PORTAL_MASK_EXTENT,
		tangentMax: PORTAL_MASK_EXTENT,
	};
	if(admitted) return [front];
	const numericAperture = Number(apertureHalfLengthPixels);
	const aperture = Number.isFinite(numericAperture) ?
		Math.max(0, numericAperture) : PORTAL_MASK_EXTENT;
	return [
		front,
		{normalMin: -PORTAL_MASK_EXTENT, normalMax: PORTAL_MASK_EXTENT, tangentMin: -PORTAL_MASK_EXTENT, tangentMax: -aperture},
		{normalMin: -PORTAL_MASK_EXTENT, normalMax: PORTAL_MASK_EXTENT, tangentMin: aperture, tangentMax: PORTAL_MASK_EXTENT},
	];
};

// Unadmitted parts of the connected island may only be previewed through the
// opening. Once admitted, their emerged portions occupy the open room and use
// the same unbounded half-plane as the source. Extending the aperture rectangle
// across that room cuts off long objects when they angle past either portal lip.
export const mirrorPortalMaskQuads = (
	apertureHalfLengthPixels = PORTAL_MASK_EXTENT,
	admitted = false,
) => {
	if(admitted) return sourcePortalMaskQuads();
	const numericAperture = Number(apertureHalfLengthPixels);
	const aperture = Number.isFinite(numericAperture) ?
		Math.max(0, numericAperture) : PORTAL_MASK_EXTENT;
	return [{
		normalMin: -PORTAL_MASK_SEAM,
		normalMax: PORTAL_MASK_EXTENT,
		tangentMin: -aperture - PORTAL_MASK_SEAM,
		tangentMax: aperture + PORTAL_MASK_SEAM,
	}];
};
